export enum EHelpSidebarView {
  Main = 'MAIN',
  KeyboardShortcuts = 'KEYBOARD_SHORTCUTS',
}
